import { useContext } from 'react'

import { InvoiceFormContext } from './invoice-form-context'

export function useInvoiceForm() {
  const ctx = useContext(InvoiceFormContext)
  if (!ctx) {
    throw new Error('useInvoiceForm must be used within InvoiceFormProvider')
  }
  return ctx
}
